import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-base',
  template: `
    <p>
      training-base works!
    </p>
  `,
  styles: [
  ]
})
export class TrainingBaseComponent implements OnInit {

  constructor() { }

  // Employee Training and My Training table stuff
  // All Tables use same structure, but diff sources
  public qualificationTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    filter: false
  };
  public qualificationTableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'buttons', label: '', type: 'dynamic', },
    { key: 'qualId', label: '', type: 'key', hidden: true },
    { key: 'qualDesc', label: 'Qualification', type: 'string', },
    { key: 'qualActive', label: 'Active ?', type: 'boolean', filterType: 'boolean', 
      width: 100, 
      tooltip: "Is the qualification still active? If unchecked this training may no longer be being assigned due to being superseded by a new training."},
    { key: 'qualRequired', label: 'Required ?', type: 'boolean', filterType: 'boolean', 
      width: 100,
      tooltip: "Is the qualification required? If checked this training is required for you to complete and keep current."},
    { key: 'current', label: 'Current ?', type: 'boolean', filterType: 'boolean', 
      width: 100,
      tooltip: "Is the qualification current? If checked, you are current on the training for this qualification by having completed all of the required tasks within the specified timeframe."},
    { key: 'qualOwner', label: 'Qual Owner', type: 'string', },
    { key: 'approvedOn', label: 'Approved On', type: 'dynamic', },
    { key: 'approvedBy', label: 'Approved By', type: 'dynamic', },
    { key: 'revokedOn', label: 'Revoked On', type: 'dynamic', },
    { key: 'revokedBy', label: 'Revoked By', type: 'dynamic', },
  ];

  public qualificationSubTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    filter: false
  };
  public qualificationSubTableHeader: AimsCommonTableHeader[] = [
    { key: 'buttons', label: '', type: 'dynamic', width: 200 },
    { key: 'qualTaskUrlLink', label: 'Training Link', type: 'dynamic', },
    { key: 'qtPreReq', label: 'Prerequisite', type: 'string', },
    { key: 'qtDesc', label: 'Qual Task Desc', type: 'string', },
    { key: 'note', label: 'Qual Task Note', type: 'string', },
    { key: 'intervalInMonths', label: 'Interval', type: 'number', width: 80 },
    { key: 'qtActive', label: 'Active', type: 'boolean', filterType: 'boolean', width: 80},
    { key: 'qtRequired', label: 'Required', type: 'boolean', filterType: 'boolean', width: 80},
    { key: 'qtHistory.revoked', label: 'Revoked', type: 'boolean', filterType: 'boolean', width: 80},
    { key: 'revokedReason', label: 'Reason Revoked', type: 'dynamic', },
    { key: 'qtWsOwner', label: 'Work Section Owner', type: 'string', },
    { key: 'completedOn', label: 'Completed On', type: 'dynamic', },
    { key: 'trainedBy', label: 'Trained By', type: 'dynamic', width: 200},
    { key: 'certifiedBy', label: 'Certified By', type: 'dynamic', },
  ];

  ngOnInit(): void {
  }

}
